(function () {
    'use strict'

    angular.module('wf.data', [
        // 'wf.common'
    ])
})()
